import { defaultCountries, parseCountry, buildCountryData } from 'react-international-phone';

/**
 * Where a lead came from — the four ways one actually arrives.
 *
 * "Cleaner" is one of ours passing on a unit she was asked about on site, which
 * is a real and distinct channel rather than a kind of referral.
 *
 * Free text in the database on purpose — a fifth channel should never need a
 * migration — but offered from one list so the same source does not end up
 * spelled three ways and split across three rows of the statistics.
 *
 * WhatsApp leads because that is where almost every inquiry actually lands.
 */
export const LEAD_SOURCES = [
    'WhatsApp',
    'Phone call',
    'Email',
    'Cleaner',
    // Set by the portal itself when somebody signs up through the app; in the
    // list so a lead can be corrected to it by hand too.
    'App',
    // A WhatsApp (or call) that carried a GADS-… ref from our Google ads —
    // entering the ref in the drawer picks this for you.
    'Google Ads',
    // Set by the portal when somebody signs up having come from an ad.
    'App - Google Ads',
];

// Which ad a portal sign-up came through, by the landing link's utm_content.
export const AD_GROUP_LABELS = {
    hosts: 'Hosts ad',
    management: 'Management companies ad',
    app: 'App ad',
};

export const DEFAULT_LEAD_SOURCE = 'WhatsApp';

/**
 * The phone input's country list, with one correction.
 *
 * react-international-phone ships no formatting mask for the UAE, so it types
 * a number out as one unbroken run — 504221936. Everybody here reads it as
 * 50 422 1936, and the rest of this page prints it that way (phoneFormat.js),
 * so the input is taught the same grouping rather than being the one place it
 * looks different.
 */
export const LEAD_COUNTRIES = defaultCountries.map((c) => {
    const country = parseCountry(c);
    return country.iso2 === 'ae'
        ? buildCountryData({ ...country, format: '.. ... ....' })
        : c;
});
